import { splitWithoutEmptyStrings } from "./helpers";

export function initializeInputFileClearing() {
    $(".clear-input-file").click(event => {
        const buttonInput = $(event.target);
        const inputFileIds = splitWithoutEmptyStrings(buttonInput.data("input-file-ids"), ",");

        $.each(inputFileIds, (index, inputFileId) => {
            const inputFile = $(`#${inputFileId}`);
            inputFile.val('');
        });
    });
}